(ns global.endor.checkout.ui.components.waiting
  (:require [global.endor.checkout.ui.components.basics :refer [column text]]
            [uix.core :refer [$ defui]]))

(defui waiting-screen [{:keys [message]}]
  ($ :div
     {:style {:position "fixed"
              :background-color "black"
              :top 0 :bottom 0 :right 0 :left 0
              :z-index 9999}}

     ($ :style {}
        "@keyframes spin {
         from { transform: rotate(0deg); }
         to { transform: rotate(360deg); }
         }")

     ($ column
        {:gap :large
         :align-items "center"
         :justify-content "space-around"
         :style {:height "100%"}}
        ($ :img
           {:style {:margin-top "auto"
                    :height 100
                    :width 100
                    :resize-mode "stretch"
                    :animation "spin 4s linear infinite"
                    :transform-origin "center"}
            :src "/images/icons/dark.png"})

        ($ text
           {:font :body
            :style {:margin-bottom "auto"}}
           (or message "Waiting...")))))
